module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"salary":"Зарплата","address":"Адрес","experience":"Опыт работы","employment":"Занятость","show":"Просмотреть страницу"}}')
  delete Component.options._Ctor
}
